module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2IiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNMTMuNDUgOC4wMDA5Mkg4TTggOC4wMDA5MlYxMy40NTA5TTggOC4wMDA5MkgyLjU3NDk1TTggOC4wMDA5MlYyLjU3NTkzIiBzdHJva2U9IiMwMDg5NDEiIHN0cm9rZS13aWR0aD0iMS42Ii8+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plus-icon.svg
// module id = SM6C
// module chunks = 1